import { GeneralExtraInfo, GeneralExtraInfoProps } from '../components/GeneralExtraInfo';

export const ShippingGeneralExtraInfoContainer: React.FC<React.PropsWithChildren<GeneralExtraInfoProps>> = (props) => {
  return <GeneralExtraInfo {...props} />;
};
